import React from 'react';

const Row = ({ params, row, sources, affids }) => {
    let td = getValues(params, row, sources, affids);

    return (
        <tr>{td}</tr>
    );
};

function getValues(params, row) {
    return params.map((param, index) => {
        const value = row[index];

        return(<td key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderError/components/Table/components/Row/index.js